import { FC } from 'react'

import { Text } from '@revolut-internal/ui-kit'

import { BreachCell } from 'components/TableCells/BreachCell'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { CountWithPercentageMetric } from 'types'

import { formatMetric, formatMetricTooltip } from '../utils/format'

type AgentCountCellProps = {
  metric: CountWithPercentageMetric | null
}

export const AgentCountCell: FC<AgentCountCellProps> = ({ metric }) => {
  if (!metric) {
    return <Text color="grey-tone-20">-</Text>
  }

  const content = formatMetric(metric)

  return (
    <BreachCell slaBreach={metric.slaBreach}>
      <Tooltip message={formatMetricTooltip(metric, 'agent')}>
        <Text>{content}</Text>
      </Tooltip>
    </BreachCell>
  )
}
